import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ClientLogin from '../../components/ClientLogin';
import HOAPortal from '../../components/HOAPortal';
import HOAClientRegister from './HOAClientRegister';
import { colors, typography } from '../../styles';

const styles = css`
  .pageIntroduction {
    text-align: center;
    max-width:900px;
    margin:0 auto 60px auto;
    p {
      font:400 16px/2 ${typography.SansSerif};
      @media (min-width: 768px) {
        font:400 18px/2 ${typography.SansSerif};
      }
    }
  }
  .ContactInfo_heading {
    font-family: ${typography.SansSerif};
    color: ${colors.color1};
    font-weight:700;
  }
  address {
    font:700 24px/1.2 ${typography.SansSerif};
    margin-bottom:60px;
    margin-top:40px;

    span {
      display:block;
      @media (min-width: 768px) {
        display:inline-block;
      }
    }
  }
  .formWrapper {
    background:whitesmoke;
    padding:30px;
    border-top:8px solid ${colors.color2};
    @media (min-width: 768px) {
      padding:100px;
    }
  }
  main {
    @media (min-width: 768px) {
      padding:60px 0 40px 0;
    }
  }
  .LoginRegister {
    display:flex;
    flex-flow:row wrap;
    justify-content: center;
  }

  .LoginRegister-Login, .LoginRegister-Register {
    width:100%;
    @media (min-width: 768px) {
      width:50%;
    }
  }
`;

function HoaPortal({ page, user, userError }) {
  return (
    <div className={styles}>
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <main>
          <div className="container">
            <div className="pageIntroduction">
              {
                get(page, 'body_copy') &&
                <div className="PageReadable_Body" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'body_copy'))} />
              }
            </div>
            {
              !user &&
              <div className="formWrapper">
                <div className="LoginRegister container">
                  <div className="LoginRegister-Login">
                    <ClientLogin
                      user={user}
                      userError={userError}
                    />
                  </div>
                  <div className="LoginRegister-Register">
                    {
                      !user &&
                      <HOAClientRegister />
                    }
                  </div>
                </div>
              </div>
            }
            {
              user &&
              <HOAPortal />
            }
          </div>
        </main>
      </PageWrapper>
    </div>
  );
}

HoaPortal.propTypes = {
  page: PropTypes.object.isRequired,
  user: PropTypes.object,
  userError: PropTypes.string,
};

HoaPortal.defaultProps = {
  user: undefined,
  userError: undefined,
};

export default withData(
  {
    page: 'hoa_portal',
    user: true,
    userError: true,
  },
  {
    required: {
      page: true,
    },
  },
)(HoaPortal);



// WEBPACK FOOTER //
// ./src/pages/HoaPortal/index.js